import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/access')({
  staticData: {
    title: ['Hybrid Cloud', 'Request Access'],
  },
  head,
  component: lazyRouteComponent(
    () => import('@/components/HybridCloudEnvironments/Onboarding/HybridCloudIntro'),
    'HybridCloudIntro',
  ),
});
